import { cn } from "@repo/ui";

/** Keep wallet / player HUD above the marketing completion shell (`z-[215]`). */
export const MARKETING_DEMO_HUD_ABOVE_COMPLETION_Z_CLASS = "z-[230]";

/** Topic comments sheet stacks above the marketing demo HUD row. */
export const MARKETING_DEMO_COMMENTS_SHEET_ABOVE_HUD_Z_CLASS = "!z-[232]";

/** Tooltips for demo HUD / map controls must sit above topic + completion overlays. */
export const MARKETING_DEMO_OVERLAY_TOOLTIP_CONTENT_CLASS = "z-[240]";

export interface MarketingDemoTopicHeaderPortalLayoutInput {
	isNarrowTopicLayout: boolean;
}

export function marketingDemoTopicHeaderPortalShellClassName(
	input: MarketingDemoTopicHeaderPortalLayoutInput,
): string {
	return cn(
		"pointer-events-none fixed inset-x-0 flex justify-between gap-3",
		MARKETING_DEMO_HUD_ABOVE_COMPLETION_Z_CLASS,
		input.isNarrowTopicLayout ? "items-center" : "items-start",
		input.isNarrowTopicLayout
			? "top-[var(--marketing-site-header-height,7rem)] px-3 pt-10 sm:px-4 sm:pt-11"
			: "top-[var(--marketing-site-header-height,7rem)] px-4 pt-4 sm:px-6 sm:pt-6",
	);
}

export function marketingDemoTopicHeaderClusterClassName(
	input: MarketingDemoTopicHeaderPortalLayoutInput,
): string {
	return cn(
		"flex min-w-0 justify-end",
		input.isNarrowTopicLayout
			? "items-center gap-2"
			: "items-start gap-2 sm:gap-3",
	);
}
